import React from "react";
import './styles.css'

const Input = ({ styles, label, placeholder, mandatory, value, onChange, disabled = false }) => {
  const componentStyles = {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      padding: "10px",
      borderRadius: "6px",
    },
    label: {
      fontSize: "14px",
      color: "#e1e1e1",
      fontWeight: "400",
    },
  };

  return (
    <div style={componentStyles.container}>
        {label && (<label style={componentStyles.label}>{mandatory ? label + " *" : label}</label>)}

        <input
            type="text"
            placeholder={placeholder}
            className="style-input"
            style={styles}
            value={value || ""}
            onChange={onChange}
            disabled={disabled}
        />
    </div>
  );
};

export default Input;